import InfiniteSearchableSelect from '../../../components/ui/SearchableSelect/InfiniteSearchableSelect';
import { fetchOrganisationListPage } from '../../intervene/adapters/organisationListAdapter';
import {
  getOrganisationId,
  getOrganisationLabel,
  isSameOrganisation,
  mapOrganisationToSelectOption,
} from '../../intervene/utils/organisationSelectUtils';
import ProfileSearchableSelect from './ProfileSearchableSelect';

export default function ProfileOrganisationSearchableSelect({
  valueId = null,
  selectedOrganisation = null,
  onChange,
  pageSize = 20,
  ...props
}) {
  return (
    <InfiniteSearchableSelect
      {...props}
      fetchPage={fetchOrganisationListPage}
      pageSize={pageSize}
      enabled
      enableSearch
      minRemoteSearchLength={2}
      searchDebounceMs={350}
      searchStrategy="remote-only"
      injectSelectedWhileSearching={false}
      valueId={valueId}
      selectedSeed={selectedOrganisation}
      mapToOption={mapOrganisationToSelectOption}
      isSameOption={isSameOrganisation}
      getOptionId={getOrganisationId}
      getOptionLabel={getOrganisationLabel}
      isOptionEqualToValue={isSameOrganisation}
      onChange={onChange}
      SelectComponent={ProfileSearchableSelect}
      placeholder={props.placeholder || 'Search and select organisation'}
      noOptionsText="No organisations found"
    />
  );
}
